import React, { Component } from "react";

import Map from "../../../../components/map";
import Modal from "../../components/modal";
import { getLatitude, getLongitude } from "../../../../utils/location";

export default class Location extends Component {
  state = {
    mapModal: false
  }

  toggleMapModal = (value) => this.setState({mapModal: value ?? !this.state.mapModal})

  render() {
    const { supplier, title } = this.props;
    
    // Use helper functions to get coordinates regardless of location source
    const latitude = getLatitude(supplier.location);
    const longitude = getLongitude(supplier.location);
    return (
      <div id={title} className="p-6 flex flex-col gap-4">
        <h3 className="text-lg font-bold">{title}</h3>
        <p className="text-sm">{supplier.location.address}</p>
        {
          latitude && longitude
          ? <button className="rounded-xl overflow-hidden" onClick={this.toggleMapModal}>
            <Map mapPadding={10} subField={"location"} suppliers={[supplier]} update={false} className="w-full h-40" />
          </button>
          : null
        }
        <Modal
          size="large"
          alignedCenter
          open={this.state.mapModal}
          title={"Location"}
          fillHeight={false}
          footer={<div/>}
          closeFn={() => this.toggleMapModal(false)}
        >
          <Map mapPadding={10} subField={"location"} suppliers={[supplier]} update={true} className="w-full h-[70vh]" />
        </Modal>
      </div>
    )
  }
}